import { useState, useContext } from "react";
import { Navbar, Button, Offcanvas, Dropdown } from "react-bootstrap";
import {
  FaShoppingCart,
  FaUser,
  FaSignInAlt,
  FaAlignJustify,
} from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import AuthModal from "./modals/AuthModal";
import "./NavbarTop.css";

export default function NavbarTop({ onToggleMenu }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useContext(AuthContext);

  const [showMiniMenu, setShowMiniMenu] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [animate, setAnimate] = useState(false);

  const handleNavigate = (path) => {
    setShowMiniMenu(showMiniMenu);
    navigate(path);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        sticky="top"
        className="py-2 px-3 d-flex justify-content-between sticky-shadow"
      >
        <div className="d-flex align-items-center">
          <div variant="outline-light" className="me-2" onClick={onToggleMenu}>
            <img
              src="/logo.jpg"
              alt="Logo"
              width="30"
              height="30"
              style={{
                objectFit: "contain",
                border: "2px solid #000", // black border
                borderRadius: "50%", // makes it circular
                padding: "2px", // optional spacing
              }}
            />
          </div>
          <Navbar.Brand
            href="https://acce.edu.gh/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ACESWA
          </Navbar.Brand>
        </div>

        {/* Desktop Nav Right */}
        <div className="d-none d-md-flex align-items-center gap-3 text-white">
          {user ? (
            <>
              <span>Hello, {user.full_name || user.email}</span>
              {/* <Button size="sm" variant="outline-light" onClick={handleLogout}>
                Logout
              </Button> */}
            </>
          ) : (
            <Button
              size="sm"
              variant="outline-light"
              onClick={() => setShowAuth("login")}
            >
              <FaSignInAlt /> Join us
            </Button>
          )}

          {user && (
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                className="text-white nav-hover border-0"
              >
                {user?.profile_url ? (
                  <img
                    src={user.profile_url || "../logo.jpg"}
                    alt="User"
                    className="rounded-circle"
                    width={40}
                    height={40}
                    style={{ objectFit: "cover" }}
                  />
                ) : (
                  <img
                    src={user.profile_url || "../logo.jpg"}
                    alt="User"
                    className="rounded-circle"
                    width={40}
                    height={40}
                    style={{ objectFit: "cover" }}
                  />
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {/* <Dropdown.Item onClick={() => navigate("/profile")}>
                  My Profile
                </Dropdown.Item> */}
                <Dropdown.Item
                  onClick={() => {
                    const role = user?.role?.toLowerCase();

                    if (!role) {
                      // user data not loaded yet
                      return;
                    }

                    if (role === "admin") {
                      navigate("/admin");
                    } else if (role === "superadmin") {
                      navigate("/admin");
                    } else if (role === "staff") {
                      navigate("/user");
                    } else {
                      navigate("/404");
                    }
                  }}
                >
                  Dashboard
                </Dropdown.Item>

                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>

        {/* Toggle Button for Mini Menu */}
        <Button
          className="d-md-none"
          variant="outline-light"
          onClick={() => setShowMiniMenu(!showMiniMenu)}
        >
          <FaAlignJustify />
        </Button>
      </Navbar>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas
        show={showMiniMenu}
        onHide={() => setShowMiniMenu(false)}
        placement="end"
        className="offcanvas-custom-width"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Dropdown.Toggle
            variant="link"
            className="text-white nav-hover border-0"
          >
            {user?.profile_url ? (
              <img
                src={user.profile_url || "../logo.jpg"}
                alt="User"
                className="rounded-circle"
                width={60}
                height={60}
                style={{ objectFit: "cover" }}
              />
            ) : (
              <FaUser />
            )}
          </Dropdown.Toggle>

          <div className="d-flex flex-column gap-3">
            {!user && (
              <div
                className="nav-hover text-dark"
                onClick={() => {
                  setShowMiniMenu(!showMiniMenu);
                  setShowAuth("login");
                }}
              >
                <FaSignInAlt className="me-2" /> Sign In
              </div>
            )}

            {user && (
              <>
                <Dropdown.Item
                  onClick={() => {
                    const role = user?.role?.toLowerCase();

                    if (!role) {
                      // user data not loaded yet
                      return;
                    }

                    if (role === "admin" || role === "superadmin") {
                      navigate("/admin");
                    } else if (role === "staff") {
                      navigate("/user");
                    } else {
                      navigate("/404");
                    }
                  }}
                >
                  Dashboard
                </Dropdown.Item>

                <div className="nav-hover text-dark" onClick={handleLogout}>
                  🚪 Logout
                </div>
              </>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Auth Modal */}
      <AuthModal
        show={!!showAuth}
        activeTab={showAuth}
        onHide={() => setShowAuth(false)}
      />
    </>
  );
}
